@if (data(); as currentData) {
	@if (translations$ | async; as translations) {
		<div class="m2">
			<!-- Grid for desktop -->
			<div class="lp-grid-desktop">
				<div class="lp-grid-text">
					<div class="lp-header">{{ currentData.serviceName }}</div>
					<div [innerHTML]="currentData.description"></div>
				</div>
				<img class="lp-grid-image" [src]="currentData.image.url" [alt]="currentData.image.title || 'Service Logo'" />
			</div>

			<!-- Grid for mobile -->
			<div class="lp-grid-mobile">
				<img [src]="currentData.image.url" [alt]="currentData.image.title || 'Service Logo'" />
				<div>
					<div class="lp-header">{{ currentData.serviceName }}</div>
					<div [innerHTML]="currentData.description" class="mb3"></div>
				</div>
			</div>

			<!-- Info section grid -->
			<div class="lp-info-grid">
				<div>
					<div class="lp-title">{{ currentData.howItWorks || translations.howItWorks }}</div>
					<div [innerHTML]="currentData.explanation"></div>
				</div>
				<div>
					<div class="lp-title">{{ translations.pricingAndDocuments }}</div>
					<div [innerHTML]="currentData.pricing"></div>
				</div>
			</div>
		</div>
	}
}
